import React, { ReactNode } from 'react';
import { Translate } from 'react-redux-i18n';
import ProfessionalInformationForm from './ProfessionalInformationForm';
import { Entity } from '../../../../../network/api/types/compte/Entity';
import compteApi from '../../../../../network/api/compteApi';

type Props = {
  onClose: () => void,
  entityId: string,
  setDirty?: (dirty: boolean, callback?: () => void) => void
  setModalI18n?: (title: string, subtitle: string) => void
};

type State = {
  entity: Entity,
};

class ProfessionalInformation extends React.Component<Props> {
  state: State = {
    entity: null,
  };

  componentDidMount(): void {
    compteApi.fetchMyUserDetails()
      .then((myUserDetails) => {
        const entity = myUserDetails.entities
          .find((entiti) => entiti.id === this.props.entityId);
        this.setState({ entity });
      });
  }

  render(): ReactNode {
    if (!this.state.entity) {
      return false;
    }
    return (
      <div className="professional-drawer">
        <div className="drawer-title">
          <h3>
            {this.state.entity.name}
          </h3>
          <div className="subtitle">
            <Translate value="PROFESSIONAL_INFORMATION.PROFESSIONAL_INFORMATION" />
          </div>
          <div className="additional-subtitle">
            <Translate value="PROFESSIONAL_INFORMATION.PUBLIC_INFORMATION" />
          </div>
        </div>
        <div className="drawer-divider-horizontal" />
        <div className="professional-content">
          <ProfessionalInformationForm
            onClose={this.props.onClose}
            idnRattachement={this.state.entity.rattachement.id}
            setDirty={this.props.setDirty}
            setModalI18n={this.props.setModalI18n}
          />
        </div>
      </div>
    );
  }
}

export default ProfessionalInformation;
